export default __webpack_public_path__ + "static/color-picker-avoid-yellow-text-dont-bfd44db3c3abd063f7bb6a9bccfb74f94a22120097cbadaa8dbcf121493aa24c.png";